export const DASHBOARD = '/dashboard';
